@if (attribute?.displayName) {
  <div class="pl-3 text-color-secondary" style="font-size: var(--p-floatlabel-active-font-size)">
    {{ attribute?.displayName }}
  </div>
}
@if (multiPick) {
  <div class="day-container">
    <div class="day-grid">
      <p-selectButton
        class="day-button"
        styleClass="!text-center !flex !items-center !justify-center"
        [options]="daysOfWeek"
        optionLabel="name"
        optionValue="code"
        optionDisabled="disabled"
        [(ngModel)]="selectedDays"
        [multiple]="true"
        (onChange)="onChange($event)"
      />
    </div>
    @if (groupButtons) {
      <div class="bottom-buttons">
        <p-button variant="outlined" class="action-button" styleClass="!py-1 !text-center !flex !items-center !justify-center" (click)="selectAllGroupE($event)"
          >All Week</p-button
        >
        <p-button
          variant="outlined"
          [disabled]="weekdaysDisabled"
          class="action-button"
          styleClass="!py-1 !text-center !flex !items-center !justify-center"
          (click)="selectWDGroupE($event)"
          >Weekdays</p-button
        >
        <p-button
          variant="outlined"
          [disabled]="weekendsDisabled"
          class="action-button"
          styleClass="!py-1 !text-center !flex !items-center !justify-center"
          (click)="selectWEGroupE($event)"
          >Weekends</p-button
        >
        @if (resetButton) {
          <p-button class="action-button" variant="outlined" styleClass="!py-1 !text-center !flex !items-center !justify-center" (click)="resetGroup()">Reset</p-button>
        } @else {
          <p-button class="action-button" variant="outlined" styleClass="!py-1 !text-center !flex !items-center !justify-center" (click)="clearGroupE($event)">Clear</p-button>
        }
      </div>
    }
  </div>
} @else {
  <p-selectButton
    styleClass="!text-center !flex !items-center !justify-center"
    [options]="daysOfWeek"
    optionLabel="name"
    optionValue="code"
    optionDisabled="disabled"
    [(ngModel)]="selectedDay"
    [multiple]="false"
    (onChange)="onChange($event)"
  />
}
